



























import {
  Component,
  Mixins,
  Watch,
  Vue,
  Prop,
  Model,
  Emit
} from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list'

@Component
export default class MatchPictureModal extends Vue {
  @Model('change', { type: Boolean }) modal!: boolean
  @Emit('change')
  change(e) {}

  @Prop({ type: Array, default: () => [] }) tasks!: {
    id: string
    code: string
    status: string
    remark: string
  }[]

  columns = [
    {
      title: '货号',
      width: 160,
      key: 'code'
    },
    {
      title: '状态',
      key: 'status'
    },
    {
      title: '备注',
      width: 360,
      key: 'remark'
    }
  ]
  cancel() {
    this.change(false)
  }
  ok() {
    this.change(false)
    this.$emit('on-change')
  }
  mounted() {
  }
  get finish() {
    return this.tasks.filter(x => x.status !== '已完成').length > 0
  }
  @Watch('modal', { immediate: true })
  modalChange(val) {
    if (val) {
      var result = []
      for (var i = 0, len = this.tasks.length; i < len; i += 2) {
        result.push(this.tasks.slice(i, i + 2).map(x => x.id))
      }
      this.items = result
      this.match(0)
    }
  }
  items: Array<Array<string>>
  match(index) {
    let p = this.items[index]
    if (p) {
      let ids = p
      this.tasks
        .filter(x => p.indexOf(x.id) > -1)
        .forEach(item => (item.status = '匹配中'))
      GoodsApi.matchProductPictures(ids).then(res => {
        setTimeout(() => {
          this.tasks
            .filter(x => p.indexOf(x.id) > -1)
            .forEach(item => {
              item.status = '已完成'
              item.remark = res.data[item.id]
            })
          this.match(++index)
        }, 100)
      })
    }
  }
}
